export default {
  PLATFORM_SELECTION: 0,
  SERVICE_SELECTION: 1,
  APPLET_INTRO: 2,
  UPSELL: 3,
  RECOMMENDED_APPLETS: 4,
}
